import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { NavbarItem } from "./NavbarItem";
export class Navbar extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._index = 0;
        this._activeItem = "";
    }
    static _template() {
        return {
            w: 1920,
            h: 128,
            Left: {
                x: 115,
                y: 30,
                h: 68,
                flex: { direction: "row", alignItems: "center" },
                Logo: {
                    w: 174,
                    h: 68,
                    flexItem: { marginRight: 32, shrink: 0 },
                    Artwork: {
                        x: 16,
                        y: 9,
                        w: 142,
                        h: 50,
                        texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/ligue-1-plus.svg"), 284, 100),
                    },
                },
                Menu: {
                    flex: { direction: "row", alignItems: "center" },
                    children: [
                        { id: "home", label: "Ligue 1", letterSpacing: -0.64 },
                        { id: "ligue3", label: "Ligue 3", letterSpacing: -0.64 },
                        { id: "schedule", label: "Schedule" },
                        { id: "on-demand", label: "On Demand" },
                        { id: "favourites", label: "Favourites" },
                    ].map((item) => ({
                        type: NavbarItem,
                        item: Object.assign(Object.assign({}, item), { kind: "label" }),
                        flexItem: { marginRight: 24 },
                    })),
                },
            },
            Right: {
                x: 1645,
                y: 30,
                w: 160,
                h: 68,
                flex: { direction: "row", alignItems: "center" },
                Search: {
                    type: NavbarItem,
                    item: { id: "search", kind: "search" },
                    flexItem: { marginRight: 24 },
                },
                Profile: {
                    type: NavbarItem,
                    item: { id: "profile", kind: "profile" },
                },
            },
        };
    }
    get activeItem() {
        return this._activeItem;
    }
    set activeItem(id) {
        this._activeItem = id;
        this.entries.forEach((item) => {
            item.patch({ activePage: item.itemId === id });
        });
    }
    _onActivated(page) {
        var _a;
        // The new page is supplied before Router.getActiveRoute() is updated.
        const [activeItem = ""] = ((_a = page[Router.symbols.hash]) !== null && _a !== void 0 ? _a : "").split(/[/?]/);
        this.activeItem = activeItem === "watch-details" ? "home" : activeItem;
        // Keep the selected item when history restores focus to this widget.
    }
    _getFocused() {
        return this.entries[this._index];
    }
    _handleLeft() {
        this._index = Math.max(0, this._index - 1);
        this._refocus();
        return true;
    }
    _handleRight() {
        this._index = Math.min(this.entries.length - 1, this._index + 1);
        this._refocus();
        return true;
    }
    _handleUp() {
        return true;
    }
    _handleDown() {
        Router.restoreFocus();
        return true;
    }
    _handleBack() {
        // Restore on release so App's back-release handler cannot also navigate.
        return true;
    }
    _handleBackRelease() {
        Router.restoreFocus();
        return true;
    }
    _handleEnter() {
        var _a;
        const itemId = (_a = this.entries[this._index]) === null || _a === void 0 ? void 0 : _a.itemId;
        if (itemId === "home") {
            Router.navigate("home");
        }
        else if (itemId === "ligue3") {
            Router.navigate("subscribe/ligue-3");
        }
        return true;
    }
    get entries() {
        return [
            ...this.tag("Left.Menu").children,
            this.tag("Right.Search"),
            this.tag("Right.Profile"),
        ];
    }
}
export default Navbar;
//# sourceMappingURL=Navbar.js.map